import { createContext, useCallback, useContext, useState } from "react";
import { useDispatch } from "react-redux";
import { fetchPermissions } from "src/slices/permission";

interface PermissionContextType {
    data: any;
    fetchPermissionsData: () => Promise<void>;
  }

const PermissionContext = createContext<PermissionContextType | undefined>(undefined)

export const usePermission = () => useContext(PermissionContext)

export const PermissionProvider = ({children}) =>{
const dispatch = useDispatch();
const [data, setData] = useState(null)

const fetchPermissionsData = useCallback(async () => {
    try {
      const res = await dispatch<any>(fetchPermissions());
      setData(res?.payload?.detail); // Update the state with the fetched permissions
    } catch (error) {
      console.error("Failed to fetch permissions:", error);
    }
  }, [dispatch]);

return(
    <PermissionContext.Provider value={{data, fetchPermissionsData}}>
        {children}
    </PermissionContext.Provider>
)
}